import React from "react";
import {
	FooterContainer,
	FooterWrapper,
	Section,
	SectionTitle,
	LinkList,
	FooterLink,
	Address,
	SocialLinks,
	SocialIcon,
	GptwImage,
	Copyright,
	LogoIcon,
} from "./styles";
import { useWindowSize } from "../../../hooks/useWindowResize";
import { size } from "../../../constants";
import { useTheme } from "../../../contexts/ThemeContext";
import { LinkedinLogo } from "../../assets/companies/linkedin-logo";
import { InstagramLogo } from "../../assets/companies/instagram-logo";
import { socialNetworks, utilityLinks } from "../../../data/contact-info";
import { useTranslation } from "next-i18next";
import { StaticI18nLink } from "../../../components/Link";

const Footer = ({ defaultTheme }) => {
	const { width } = useWindowSize();
	const { theme: hookTheme } = useTheme();
	const theme = defaultTheme || hookTheme;
	const { t } = useTranslation();

	const isDarkTheme = theme === "dark";
	const isLaptop = width >= size.laptop;

	const getLogoPath = {
		dark: {
			laptop: "/landings/assets/images/LogoVerzelHorizontal.svg",
			mobile: "/landings/assets/images/logo_icon_verzel_white.svg",
		},
		light: {
			laptop: "/blog/assets/svg/logo-vertical-black.svg",
			mobile: "/blog/assets/svg/logo-horizontal-black.svg",
		},
	};

	return (
		<FooterContainer>
			<FooterWrapper className="container-blog">
				<Section>
					<LogoIcon
						src={getLogoPath[theme][isLaptop ? "laptop" : "mobile"]}
						alt="Verzel"
					/>
				</Section>

				<Section>
					<LinkList>
						<StaticI18nLink href="/cases/1">
							<FooterLink>{t("footer.customerCases")}</FooterLink>
						</StaticI18nLink>
						<StaticI18nLink href="/blog">
							<FooterLink>{t("footer.latestNews")}</FooterLink>
						</StaticI18nLink>
						<FooterLink
							rel="noopener"
							target="_blank"
							href={utilityLinks.workWithUs}
						>
							{t("footer.joinOurTeam")}
						</FooterLink>
						<StaticI18nLink href="/privacy-policy">
							<FooterLink>{t("footer.privacyPolicy")}</FooterLink>
						</StaticI18nLink>
					</LinkList>
				</Section>

				<Section>
					<SectionTitle>{t("footer.address")}</SectionTitle>
					<div className="d-flex flex-column gap-2 align-items-lg-start align-items-center">
						<Address>Rua Aníbal Benévolo, 94 - 2° Andar</Address>
						<Address>Santana - São Paulo/SP - CEP 02016-040</Address>
					</div>
				</Section>

				<Section>
					<SectionTitle>{t("footer.socialNetworks")}</SectionTitle>
					<SocialLinks>
						<SocialIcon
							href={socialNetworks.instagram}
							target="_blank"
							rel="noopener noreferrer"
						>
							<InstagramLogo color={isDarkTheme ? "#FFF" : "#1D202A"} />
						</SocialIcon>
						<SocialIcon
							href={socialNetworks.linkedin}
							target="_blank"
							rel="noopener noreferrer"
						>
							<LinkedinLogo color={isDarkTheme ? "#FFF" : "#1D202A"} />
						</SocialIcon>
					</SocialLinks>
				</Section>

				{isLaptop && (
					<Section>
						<GptwImage
							src="/landings/assets/icons/gptw.svg"
							alt="Great Place to Work"
						/>
					</Section>
				)}
			</FooterWrapper>

			<Copyright>
				Copyright © {new Date().getFullYear()} Verzel. {t("footer.copyright")}
			</Copyright>
		</FooterContainer>
	);
};

export { Footer };
